import { render, staticRenderFns } from "./EditCustomerDetailsModal.vue?vue&type=template&id=73fa3230&scoped=true"
import script from "./EditCustomerDetailsModal.vue?vue&type=script&lang=js"
export * from "./EditCustomerDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fa3230",
  null
  
)

export default component.exports